import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ITableServerResponseFilter } from 'src/app/common/interfaces/table/table-server-filter-response.interface';
import { ITableServerFilter } from 'src/app/common/interfaces/table/table-server-filter.inteface';
import { AbstractRtpCorrespondentReconService } from '../abstraction/abstract.correspondent-reconcilation.service';
import { lastValueFrom } from 'rxjs';
import { IReconTransactions } from '../../interfaces/reconciliation/correspondent/correspondent-recon-transaction.interface';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MockRtpCorrespondentReconService extends AbstractRtpCorrespondentReconService {
  private tableFilterJson = 'assets/mocks/rtp/reconciliation-correspondent/tableFilter.json';
  private reconTransactionsJson =
    'assets/mocks/rtp/reconciliation-correspondent/getReconTransactionsByCycle.json';

  constructor(private http: HttpClient) {
    super();
  }

  override tableFilter(
    filter: ITableServerFilter
  ): Promise<ITableServerResponseFilter | undefined> {
    return lastValueFrom(this.http.get<ITableServerResponseFilter>(this.tableFilterJson));
  }
  override tableExportCSV(filter: ITableServerFilter): Promise<Blob | undefined> {
    throw new Error('Method not implemented.');
  }
  override tableExportExcel(filter: ITableServerFilter): Promise<any> {
    throw new Error('Method not implemented.');
  }

  override getReconciliationDetails(
    cycleDate: string,
    reconWindowId: number
  ): Promise<IReconTransactions[] | undefined> {
    return lastValueFrom(
      this.http
        .get<IReconTransactions[]>(this.reconTransactionsJson)
        .pipe(
          map(transactions =>
            transactions.filter(transaction => transaction.reconWindowId === reconWindowId)
          )
        )
    );
  }
}
